// Vendors
import React, { useState } from 'react';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Configure } from 'react-instantsearch-dom';

// Components
import RebatesSearchFilters from './RebatesSearchFilters';
import RebatesSearchTable from './RebatesSearchTable';
import NationalRebatesSearchFilters from './NationalRebatesSearchFilters';
import NationalRebatesSearchTable from './NationalRebatesSearchTable';
import { Pagination } from '../../algolia/components';

// Config
import {
  ENV,
  ALGOLIA_APP_ID,
  ALGOLIA_SEARCH_API_KEY
} from '../../config/index';

// Helpers
import { scrollToElement } from '../../lib/utilities';

const environment = ENV === 'dev' ? 'local' : ENV;
const algoliaClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY);

const RebatesSearch = ({ index }) => {
  const algoliaIndex = `perc_${environment}_${index}`;
  const isNationalIndex = index === 'national_grants' ? true : false;
  const [searchState, setSearchState] = useState({
    index: algoliaIndex,
    sort: { column: null, direction: null }
  });

  const handleSearchStateChange = (newSearchState) => {
    scrollToElement(document.getElementById('app-rebates-search'));
    setSearchState(newSearchState);
  };

  const handleSort = (event, column) => {
    event.preventDefault();

    let newIndex = `${algoliaIndex}`;
    let newColumn = null;
    let newDirection = null;

    if (column)
      newDirection = column === searchState.sort.column ? 'desc' : 'asc';

    if (
      column === searchState.sort.column &&
      newDirection === searchState.sort.direction
    )
      newDirection = null;

    if (newDirection) {
      newColumn = column;
      newIndex = `${algoliaIndex}_replica_${newColumn}_${newDirection}`;
    }

    setSearchState({
      ...searchState,
      page: 1,
      index: newIndex,
      sort: { column: newColumn, direction: newDirection }
    });
  };

  return (
    <InstantSearch
      indexName={searchState.index}
      searchClient={algoliaClient}
      searchState={searchState}
      onSearchStateChange={handleSearchStateChange}
    >
      <Configure hitsPerPage={15} />
      {isNationalIndex ? (
        <NationalRebatesSearchFilters />
      ) : (
        <RebatesSearchFilters />
      )}
      {isNationalIndex ? (
        <NationalRebatesSearchTable
          searchState={searchState}
          handleSort={handleSort}
        />
      ) : (
        <RebatesSearchTable searchState={searchState} handleSort={handleSort} />
      )}
      <Pagination />
    </InstantSearch>
  );
};

export default RebatesSearch;
